<template>
  <div
    class="basic-radio flex items-center space-x-1"
    :class="[
      disabled && 'basic-radio-state-disabled',
      isSelected && 'basic-radio-state-selected',
    ]"
    @click="onSelect"
  >
    <div class="basic-radio-icon flex-shrink-0 relative m-px">
      <BaseIcon
        icon="checkbox-outer"
        class="basic-radio-icon-outer"
        :size="16"
      />
      <BaseIcon
        icon="checkbox-inner"
        class="basic-radio-icon-inner absolute inset-0"
        :size="16"
      />
    </div>
    <div v-if="$slots.default" class="label flex-grow-0 min-w-0 break-words">
      <!-- @slot 点の右に出る内容 -->
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from 'vue-demi';

import { useBaseRadioContext } from '@/hooks/use_base_radio';

import BaseIcon from './BaseIcon.vue';

export default defineComponent({
  name: 'BaseRadio',
  components: {
    BaseIcon,
  },
  props: {

    /**
     * このラジオのグループのv-modelから発行される値
     */
    value: {
      type: null,
      required: true,
    },

    /**
     * disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { disabled, value } = toRefs(props);
    const { selection } = useBaseRadioContext();
    const isSelected = computed(() => selection.value === value.value);

    function onSelect() {
      if (disabled.value) return;

      selection.value = value.value;
    }

    return {
      isSelected,
      onSelect,
    };
  },
});
</script>

<style lang="scss" scoped>
.basic-radio {
  cursor: pointer;
  // ボーダーデフォルト
  .basic-radio-icon-outer {
    color: theme('colors.gray.900');
  }

  // 活性時 未選択
  .basic-radio-icon-inner {
    color: theme('colors.transparent');
  }

  // 活性時 ホバー
  &:hover {
    .basic-radio-icon-inner {
      color: theme('colors.gray.300');
    }
  }

  // 活性時 選択
  &.basic-radio-state-selected {
    .basic-radio-icon-inner {
      color: theme('colors.gray.900');
    }
  }

  // 非活性時
  &.basic-radio-state-disabled {
    cursor: default;
    .basic-radio-icon-outer {
      color: theme('colors.gray.300');
    }
    .label {
      color: theme("colors.gray.300");
    }

    // 非活性時 未選択&ホバー
    .basic-radio-icon-inner {
      color: theme('colors.transparent');
    }

    // 非活性時 選択
    &.basic-radio-state-selected {
      .basic-radio-icon-inner {
        color: theme('colors.gray.300');
      }
    }
  }
}

</style>
